import { useState } from 'react';

import { AuthShowContainer } from 'modules/auth';
import { useI18n } from 'modules/i18n';
import { Helmet } from 'react-helmet';

import { EditViewOrRedirect } from '../../components';
import InterviewForm from './InterviewForm';

export default function EditInterviewPage() {
    const [showForm, setShowForm] = useState(true);
    const { t } = useI18n();

    return (
        <EditViewOrRedirect>
            <div className="wrapper-content register">
                <Helmet>
                    <title>{t('edit.interview.new')}</title>
                </Helmet>
                <AuthShowContainer hasProjectAccess>
                    <h1 className="Page-main-title">
                        {t('edit.interview.new')}
                    </h1>
                    {showForm ? (
                        <InterviewForm
                            submitText="edit.interview.new"
                            withContributions
                            onSubmitCallback={() => setShowForm(false)}
                        />
                    ) : (
                        <div>
                            <p>{t('edit.interview.processed')}</p>
                            <button
                                type="button"
                                className="Button return-to-upload"
                                onClick={() => setShowForm(true)}
                            >
                                {t('edit.interview.return')}
                            </button>
                        </div>
                    )}
                </AuthShowContainer>
                <AuthShowContainer ifLoggedOut ifNoProject>
                    {t('devise.failure.unauthenticated')}
                </AuthShowContainer>
            </div>
        </EditViewOrRedirect>
    );
}
